import { FormControl, InputLabel } from "@deere/fuel-react";
import { Row, Col } from "../../components/Layout";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { Button } from "@deere/fuel-react";

const ShipHoldDialog = ({
  open,
  onClose,
  shipHoldForm,
  setShipHoldForm,
  handleShipHoldConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        className: "w-[500px] h-[310px]",
      }}
    >
      <DialogTitle>Confirm Ship Hold</DialogTitle>
      <DialogContent>
        <Row className="flex gap-8 justify-between">
          <Col className="flex-1">
            <FormControl fullWidth margin="normal">
              <InputLabel className="text-lg font-semibold">
                Reason <span className="text-red-500">*</span>
              </InputLabel>
              <select
                value={shipHoldForm.reason}
                onChange={(e) =>
                  setShipHoldForm({ ...shipHoldForm, reason: e.target.value })
                }
                required
                className="h-10 p-2 text-xs border border-gray-400 rounded w-full box-border focus:outline focus:shadow block"
              >
                <option value="">Select a reason</option>
                <option value="quality">Quality</option>
                <option value="documents">Documents</option>
                <option value="marketing">Marketing</option>
                <option value="field team">Field Team</option>
                <option value="other">Other</option>
              </select>
            </FormControl>
          </Col>
          <Col className="flex-1">
            <FormControl fullWidth margin="normal">
              <InputLabel className="text-lg font-semibold">
                Estimated Release Date <span className="text-red-500">*</span>
              </InputLabel>
              <input
                required
                name="releaseDate"
                type="date"
                value={shipHoldForm.estimatedReleaseDate}
                onKeyDown={(e) => e.preventDefault()}
                min={new Date().toISOString().slice(0, 10)}
                onChange={(e) =>
                  setShipHoldForm({
                    ...shipHoldForm,
                    estimatedReleaseDate: e.target.value,
                  })
                }
                className="h-10 p-2 text-xs border border-gray-400 rounded w-full box-border focus:outline focus:shadow block"
              />
            </FormControl>
          </Col>
        </Row>
        <InputLabel className="mt-2">Comments (optional)</InputLabel>
        <textarea
          className="text-sm w-full p-2 form-control outline-green-500 focus:shadow-md border-gray-500 border-2 rounded-sm"
          placeholder="Add any additional comments here"
          name="freetext"
          rows={3}
          maxLength="400"
          onChange={(e) =>
            setShipHoldForm({ ...shipHoldForm, comments: e.target.value })
          }
        ></textarea>
      </DialogContent>
      <DialogActions className="mr-2">
        <Button  onClick={onClose} variant="secondary">
          Cancel
        </Button>
        <Button
          onClick={handleShipHoldConfirm}
          variant="primary"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShipHoldDialog;
